import { Switch } from "@headlessui/react";
import { classNames } from "../../helpers";
type SwitchToggleProps = {
  enabled: boolean;
  setEnabled: any;
  children: React.ReactNode;
};

export default function SwitchToggle({
  enabled,
  setEnabled,
  children,
}: SwitchToggleProps) {
  return (
    <Switch.Group as="div" className="flex items-center">
      <Switch
        checked={enabled}
        onChange={setEnabled}
        className={classNames(
          enabled ? "bg-brandblue-600" : "bg-gray-200",
          "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brandblue-500"
        )}
      >
        <span
          aria-hidden="true"
          className={classNames(
            enabled ? "rtl:-translate-x-5 ltr:translate-x-5" : "translate-x-0",
            "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"
          )}
        />
      </Switch>
      <Switch.Label as="span" className="rtl:mr-3 ltr:ml-3">
        {children}
      </Switch.Label>
    </Switch.Group>
  );
}
